module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title is-2"
  }, [_vm._v("Services")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns is-vcentered reverse-row-order"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h3', {
    staticClass: "subtitle is-3 service-title"
  }, [_vm._v("One-to-one coaching")]), _vm._v(" "), _c('div', {
    staticClass: "service-description"
  }, [_c('p', [_vm._v("I offer private lessons within London, or online worldwide! I will provide you with an individually tailored coaching programme of fun and engaging lessons. Check out some "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("student testimonials")]), _vm._v(" to see what you are missing.")], 1), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("If you have the time and willingness to improve your game, one-to-one coaching is the way forward. Please get in touch to find out about my competitive rates and what's included.")])])])]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/Phil2.jpg"),
      "alt": "Chess clubs in schools"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h3', {
    staticClass: "subtitle is-3 service-title"
  }, [_vm._v("Chess clubs in schools")]), _vm._v(" "), _c('div', {
    staticClass: "service-description"
  }, [_c('p', [_vm._v("I have taught in over 20 schools across London since 2013, offering children of all ages the chance to learn chess in a supportive, professional and - most importantly - fun setting. I see extra-curricular clubs as a place to develop skills that are necessary beyond the classroom. Chess offers a platform to learn about planning, problem solving, teamwork and sportsmanship.")]), _vm._v(" "), _c('p', [_vm._v("Each term I run internal club tournaments, awarding prizes including trophies for the top finishers and the most improved players. In the spring term I enter schools into the qualification rounds of the "), _c('a', {
    attrs: {
      "href": "https://www.delanceyukschoolschesschallenge.com/",
      "target": "_blank"
    }
  }, [_vm._v("Delancey UK Schools’ Chess Challenge")]), _vm._v(". In addition there are opportunities to compete in team events such as She Plays To Win, online interschool battles, and the "), _c('a', {
    attrs: {
      "href": "https://www.epsca.org.uk/npscc.html",
      "target": "_blank"
    }
  }, [_vm._v("National Primary School Championships")]), _vm._v(".")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/Phil7.png"),
      "alt": "One-to-one coaching"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/janflyer.jpg"),
      "alt": "Online courses"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h3', {
    staticClass: "subtitle is-3 service-title"
  }, [_vm._v("Online courses")]), _vm._v(" "), _c('div', {
    staticClass: "service-description"
  }, [_c('p', [_vm._v("I also offer intensive group courses for adult beginners and improvers. I initially introduced them to offer parents a chance to learn alongside their children whom I already teach, but the pandemic and the release of The Queen's Gambit broadened their appeal. The next course is in early 2023. Opposite is the flyer for it. Places are limited so don't delay!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e1b8d636","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Services.vue
// module id = 41
// module chunks = 0